import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuModel } from '../model/menu.model';
import { MenuService } from '../menu.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';
@Component({
  selector: 'app-menu-edit',
  templateUrl: './menu-edit.component.html',
  styleUrls: ['./menu-edit.component.scss'],
  standalone: false
})
export class MenuEditComponent implements DirtyCheck {
  title: string = "New Menu";
  editForm!: FormGroup;
  menuInfo: MenuModel = { departments: [], is_active: 1 };
  isFormDirty: boolean = false;
  ratingList: MenuModel[] = [];
  context: any;
  departments: any;
  selectedDepartments: any[] = [];
  permission: any;
  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private menuService: MenuService,
    private snackBarService: SnackBarService, private permissionService: PermissionService,
    public dialog: MatDialog,) {

    let menuId = this.route.snapshot.paramMap.get('id');


    if (menuId !== null && parseInt(menuId) !== 0) {
      this.setMenuInfo(menuId);
    }
    else {
      this.getMenuDepartments();
      this.initForm();
    }
    this.permission = permissionService.getPagePermission('menu');
  }
  ngOnInit(): void {
    //  this.loadRating();  
  }

  getMenuDepartments() {
    this.menuService.getMenuDepartments().subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.departments = response.data.departments;
          this.initForm();
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get expense type from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  initForm() {
    this.editForm = this.builder.group({
      code: this.builder.control(this.menuInfo.code, [Validators.required, Validators.maxLength(10)]),
      name: this.builder.control(this.menuInfo.name, [Validators.required, Validators.maxLength(50)]),
      description: this.builder.control(this.menuInfo.description),
      enable_h1_button: this.builder.control(!!Number(this.menuInfo.enable_h1_button)),
      enable_h2_button: this.builder.control(!!Number(this.menuInfo.enable_h2_button)),
      enable_h3_button: this.builder.control(!!Number(this.menuInfo.enable_h3_button)),
      color: this.builder.control(this.menuInfo.color),
      // departments: this.builder.control([]),
      is_active: this.builder.control(Number(this.menuInfo.is_active))
    });
    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });
  }

  /**
   * Dirtyness check
   * @returns 
   */
  isDirty(): boolean {
    return this.isFormDirty;
  }

  /**
   * checks the form is edited
   */
  navBack(): void {

    this.router.navigate(['/product/menu']);

  }

  /**
   * If tas is is null set an empty menu info
   * if menu id is not null call api to retrive the info
   * @param menuId 
   */
  setMenuInfo(menuId: any): void {

    let response = this.menuService.getMenuById(menuId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.menuInfo = response.data.menu;
          this.departments = response.data.departments.map((dep: any) => ({
            ...dep,
            isSelected: !!dep.menu_id
          }));
          this.selectedDepartments = this.departments.filter((dep: any) => dep.isSelected);
          this.title = this.getTitle();
          this.initForm();
          //  this.editForm.patchValue(this.menuInfo);
          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }


  /**
   * 
   * @returns  the title for the dialog
   * sine the same dialog is used for edit and new, dynamically decide the title
   */
  getTitle(): string {
    let title = (this.menuInfo.id == 0 || this.menuInfo.id == undefined) ? "New Menu" : "Editing : " + this.menuInfo.name;
    return title;
  }
  onDepartmentCheckboxChange(event: any, department: any, index: number) {
    if (event.checked) {
      // Add if not already present
      if (!this.selectedDepartments.find(dep => dep.id === department.id)) {
        this.selectedDepartments.push(department);
      }
    } else {
      // Remove unchecked
      this.selectedDepartments = this.selectedDepartments.filter(dep => dep.id !== department.id);
    }
    // console.log('Selected Departments:', this.selectedDepartments);
  }
  /**
     * On save
     * if the details are valid call the api to update the changes.
     */
  save(): void {
    if (this.editForm.valid) {
      this.editForm.markAllAsTouched();
      this.menuInfo.departments = this.selectedDepartments;
      Object.assign(this.menuInfo, this.editForm.value);
      this.menuService.update(this.menuInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            // handle success
            this.isFormDirty = false;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + this.menuInfo.name + " has been updated succesfully."
            }
            this.snackBarService.openSnackBar(snckBarData);
            this.router.navigate(['/product/menu']);

          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);


          }
        },
        error: (error) => {
          // handle error
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });

    } else {
      this.editForm.markAllAsTouched();
    }
  }

}
